import { MapPin, Zap, SlidersHorizontal, Handshake } from "lucide-react";
import { Reveal } from "./Reveal";

const BLOCKS = [
    {
        icon: MapPin,
        title: "Proximité",
        text: "Un échange direct avec un interlocuteur qui comprend les contraintes opérationnelles d'un chantier.",
        testid: "whyus-block-proximite",
    },
    {
        icon: Zap,
        title: "Réactivité",
        text: "Une demande simple permettant d'identifier rapidement votre besoin.",
        testid: "whyus-block-reactivite",
    },
    {
        icon: SlidersHorizontal,
        title: "Solution personnalisée",
        text: "Nous étudions chaque demande selon le matériel, la durée, le lieu et les contraintes du chantier.",
        testid: "whyus-block-personnalisee",
    },
    {
        icon: Handshake,
        title: "Accompagnement",
        text: "Du premier échange jusqu'à la mise en place de la solution retenue.",
        testid: "whyus-block-accompagnement",
    },
];

export const WhyUs = () => (
    <section id="pourquoi" data-testid="whyus-section" className="bg-ink py-24 lg:py-36">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <Reveal className="mb-14 max-w-2xl lg:mb-20">
                <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-signal">
                    04 — Pourquoi NEBOORZY
                </p>
                <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                    Un interlocuteur terrain avant tout
                </h2>
            </Reveal>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {BLOCKS.map((b, i) => (
                    <Reveal key={b.title} delay={i * 0.1}>
                        <div
                            data-testid={b.testid}
                            className="group h-full rounded-2xl border border-white/10 bg-steel p-7 transition-colors hover:border-signal/50"
                        >
                            <span className="grid h-12 w-12 place-items-center rounded-xl bg-signal/10 text-signal transition-colors group-hover:bg-signal group-hover:text-ink">
                                <b.icon className="h-6 w-6" />
                            </span>
                            <h3 className="mt-5 font-display text-lg font-bold text-white sm:text-xl">{b.title}</h3>
                            <p className="mt-2.5 text-sm leading-relaxed text-zinc-400">{b.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
